import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

interface LandingFooterProps {
    onHelpCenter?: () => void;
    onPrivacyPolicy?: () => void;
}

export const LandingFooter: React.FC<LandingFooterProps> = ({ onHelpCenter, onPrivacyPolicy }) => {
    return (
        <footer className="landing-footer">
            <div className="footer-content">
                <div>
                    <div className="nav-logo mb-6 flex items-center gap-3">
                        <img src="/notescape.png" alt="NoteSpace" className="w-10 h-10 rounded-xl shadow-lg" />
                        <span className="text-xl font-bold tracking-tight text-white">NoteSpace</span>
                    </div>
                    <p className="text-slate-400 max-w-sm mb-6">
                        The next generation of note-taking. Unlock your creativity with
                        an infinite canvas powered by AI.
                    </p>
                    <div className="flex gap-4">
                        <a href="https://github.com/Jay41199" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition" aria-label="Github">
                            <Github className="w-5 h-5" />
                        </a>
                        <a href="https://x.com/introvert_jay5" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition" aria-label="X (formerly Twitter)">
                            {/* Custom X Logo */}
                            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                            </svg>
                        </a>
                        <a href="https://in.linkedin.com/in/jainis-patel-b2698b220" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition" aria-label="LinkedIn">
                            <Linkedin className="w-5 h-5" />
                        </a>
                        <a href="mailto:jainispatel99@gmail.com" className="text-slate-400 hover:text-white transition" aria-label="Email support">
                            <Mail className="w-5 h-5" />
                        </a>
                    </div>
                </div>

                <div className="footer-links-grid">
                    <div className="footer-col">
                        <h4>Product</h4>
                        <ul>
                            <li><a href="#features">Features</a></li>
                            <li><a href="#ai">Smart View AI</a></li>
                            <li><a href="#how-it-works">How It Works</a></li>
                            <li><a href="#">Pricing</a></li>
                            <li><a href="#">Changelog</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Resources</h4>
                        <ul>
                            <li><a href="#">Community</a></li>
                            <li>
                                <button
                                    onClick={(e) => { e.preventDefault(); onHelpCenter?.(); }}
                                    className="text-left hover:text-white transition cursor-pointer"
                                >
                                    Help Center
                                </button>
                            </li>
                            <li><a href="#">Templates</a></li>
                            <li><a href="#">Blog</a></li>
                            <li><a href="#">API Docs</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Company</h4>
                        <ul>
                            <li><a href="#">About Us</a></li>
                            <li><a href="#">Careers</a></li>
                            <li><a href="#">Legal</a></li>
                            <li>
                                <button
                                    onClick={(e) => { e.preventDefault(); onPrivacyPolicy?.(); }}
                                    className="text-left hover:text-white transition cursor-pointer"
                                >
                                    Privacy Policy
                                </button>
                            </li>
                            <li><a href="#">Contact</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="max-w-1200 mx-auto mt-12 pt-8 border-t border-white/10 text-center text-slate-500 text-sm">
                <p>&copy; {new Date().getFullYear()} NoteSpace. All rights reserved.</p>
            </div>
        </footer>
    );
};
